// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
#registration-page .logo {
    text-align: center;
}
@media (width > 700px) {
    #registration-page {
        margin: 0px auto;
        box-sizing: border-box;
        display: block;
        padding: 20px;
        width: 600px;
        border: thin solid var(--main-border-color);
        background-color: white;
        border-radius: 10px;
        box-shadow: 0 0 7px -5px rgba(0,0,0,0.25);
        z-index:101;
    }
}
@media (width <= 700px) {
    #registration-page {
        box-sizing: border-box;
        display: block;
        padding: 10px;
        width: 100%;
        border-top: thin solid var(--main-border-color);
        border-bottom: thin solid var(--main-border-color);
        background-color: white;
        z-index:101;
    }
}
`, "",{"version":3,"sources":["webpack://./client/pages/authentication/RegistrationPage.css"],"names":[],"mappings":";AACA;IACI,kBAAkB;AACtB;AACA;IACI;QACI,gBAAgB;QAChB,sBAAsB;QACtB,cAAc;QACd,aAAa;QACb,YAAY;QACZ,2CAA2C;QAC3C,uBAAuB;QACvB,mBAAmB;QACnB,yCAAyC;QACzC,WAAW;IACf;AACJ;AACA;IACI;QACI,sBAAsB;QACtB,cAAc;QACd,aAAa;QACb,WAAW;QACX,+CAA+C;QAC/C,kDAAkD;QAClD,uBAAuB;QACvB,WAAW;IACf;AACJ","sourcesContent":["\n#registration-page .logo {\n    text-align: center;\n}\n@media (width > 700px) {\n    #registration-page {\n        margin: 0px auto;\n        box-sizing: border-box;\n        display: block;\n        padding: 20px;\n        width: 600px;\n        border: thin solid var(--main-border-color);\n        background-color: white;\n        border-radius: 10px;\n        box-shadow: 0 0 7px -5px rgba(0,0,0,0.25);\n        z-index:101;\n    }\n}\n@media (width <= 700px) {\n    #registration-page {\n        box-sizing: border-box;\n        display: block;\n        padding: 10px;\n        width: 100%;\n        border-top: thin solid var(--main-border-color);\n        border-bottom: thin solid var(--main-border-color);\n        background-color: white;\n        z-index:101;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
